import React from "react";
import { Nav, Tab } from "react-bootstrap";
import { useSearchParams } from "react-router";
import { CheckSquare } from "react-feather";
import { DomainValidation } from "./domain-validation";
import { MerchantMap } from "./merchant-map";
import { ProductMap } from "./product-map";

type TabKey = "domain" | "products" | "merchant-map";

const TABS: { key: TabKey; label: string; hint: string }[] = [
  {
    key: "domain",
    label: "Domain / Geo",
    hint: "Everything we hold for one domain in one geo",
  },
  {
    key: "products",
    label: "Product Map",
    hint: "Search the product feed and open real product pages",
  },
  {
    key: "merchant-map",
    label: "Merchant Map",
    hint: "Selector coverage for a domain",
  },
];

export const OpenDataValidation: React.FC = () => {
  const [params, setParams] = useSearchParams();
  const active = (params.get("view") as TabKey) ?? "domain";

  return (
    <div>
      <h4 className="mb-1">
        <CheckSquare size={20} className="me-2" />
        Open Data Validation
      </h4>
      <p className="text-muted small">
        Read-only checks against the Kindred Open Data APIs, for reviewing what
        we publish to partners.
      </p>

      <Tab.Container
        activeKey={active}
        onSelect={(k) => k && setParams({ view: k }, { replace: true })}
      >
        <Nav variant="tabs" className="mb-3">
          {TABS.map((t) => (
            <Nav.Item key={t.key}>
              <Nav.Link eventKey={t.key} title={t.hint}>
                {t.label}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="domain" mountOnEnter unmountOnExit={false}>
            <DomainValidation />
          </Tab.Pane>
          <Tab.Pane eventKey="products" mountOnEnter unmountOnExit={false}>
            <ProductMap />
          </Tab.Pane>
          <Tab.Pane eventKey="merchant-map" mountOnEnter unmountOnExit={false}>
            <MerchantMap />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
};
